// Kebab-case slugs only; caps length to prevent oversized query strings reaching the heroes API.
const CAMPAIGN_HERO_SLUG_PATTERN = /^[a-z0-9-]{1,80}$/

export function parseCampaignHeroSlug(slug: unknown): string | undefined {
    if (typeof slug !== 'string') return undefined
    return CAMPAIGN_HERO_SLUG_PATTERN.test(slug) ? slug : undefined
}
